"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELIVERY_STATUS_CATEGORY = exports.MESSAGES = void 0;
const entity_1 = require("@powerednow/complexData/entity");
const date_1 = require("@powerednow/shared/modules/utilities/date");
var constants_1 = require("@powerednow/shared/constants");
Object.defineProperty(exports, "MESSAGES", { enumerable: true, get: function () { return constants_1.MESSAGES; } });
var DELIVERY_STATUS_CATEGORY;
(function (DELIVERY_STATUS_CATEGORY) {
    DELIVERY_STATUS_CATEGORY["process_failed"] = "process_failed";
    DELIVERY_STATUS_CATEGORY["processed"] = "processed";
    DELIVERY_STATUS_CATEGORY["sent"] = "sent";
    DELIVERY_STATUS_CATEGORY["rejected"] = "rejected";
    DELIVERY_STATUS_CATEGORY["open"] = "open";
    DELIVERY_STATUS_CATEGORY["click"] = "click";
    DELIVERY_STATUS_CATEGORY["reported"] = "reported";
    DELIVERY_STATUS_CATEGORY["deferred"] = "deferred";
})(DELIVERY_STATUS_CATEGORY || (exports.DELIVERY_STATUS_CATEGORY = DELIVERY_STATUS_CATEGORY = {}));
const sanitizeExtInjection = (newValue) => {
    const matcher = /{%|%}|{\[|\]}/g;
    let cleanValue = newValue;
    while (cleanValue && cleanValue.match(matcher)) {
        cleanValue = cleanValue.replace(matcher, '');
    }
    return cleanValue;
};
let MessageRecipientEntity = class MessageRecipientEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], MessageRecipientEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, serverOnly: true })
], MessageRecipientEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], MessageRecipientEntity.prototype, "message_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], MessageRecipientEntity.prototype, "contact_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true })
], MessageRecipientEntity.prototype, "user_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', codeName: 'contactMethodTypeId' })
], MessageRecipientEntity.prototype, "contactmethodtype_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', codeName: 'messageTemplateId', allowNull: true })
], MessageRecipientEntity.prototype, "message_template_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], MessageRecipientEntity.prototype, "recipient", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], MessageRecipientEntity.prototype, "recipientName", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', processor: sanitizeExtInjection })
], MessageRecipientEntity.prototype, "subject", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', processor: sanitizeExtInjection })
], MessageRecipientEntity.prototype, "message", void 0);
__decorate([
    (0, entity_1.field)({ defaultValue: 0, type: 'int' })
], MessageRecipientEntity.prototype, "status", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', defaultValue: date_1.getNow })
], MessageRecipientEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date' })
], MessageRecipientEntity.prototype, "dt_sent", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: 0 })
], MessageRecipientEntity.prototype, "opens", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: 0 })
], MessageRecipientEntity.prototype, "clicks", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true, defaultValue: 0 })
], MessageRecipientEntity.prototype, "msg_error_code", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', allowNull: true, defaultValue: '' })
], MessageRecipientEntity.prototype, "msg_error_message", void 0);
__decorate([
    (0, entity_1.field)({ defaultValue: 0, type: 'string' })
], MessageRecipientEntity.prototype, "provider_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', isJSON: true, defaultValue: {} })
], MessageRecipientEntity.prototype, "templateData", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'boolean', codeName: 'isArchived', serverOnly: true, defaultValue: false,
    })
], MessageRecipientEntity.prototype, "is_archived", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], MessageRecipientEntity.prototype, "dt_archived", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'isDeleted', serverOnly: true })
], MessageRecipientEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], MessageRecipientEntity.prototype, "dt_deleted", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'dontTrack', defaultValue: false })
], MessageRecipientEntity.prototype, "dontTrack", void 0);
MessageRecipientEntity = __decorate([
    entity_1.EntityDecorator
], MessageRecipientEntity);
exports.default = MessageRecipientEntity;
//# sourceMappingURL=../../../../src/models/messageRecipient/entity.js.map